import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import './i18n';

import App from './App';
import { registerServiceWorker } from './utils/registerSW';
import { installErrorTracker } from './utils/errorTracker';

// iter 337 — Deploy után a régi JS-chunk eltűnik: egyszeri automatikus újratöltés (R6)
const chunkReload = (msg) => {
  if (!/ChunkLoadError|Loading chunk [\w-]+ failed|Loading CSS chunk/.test(String(msg || ''))) return;
  const key = 'acx_chunk_reload';
  const last = Number(sessionStorage.getItem(key) || 0);
  if (Date.now() - last < 60000) return;
  sessionStorage.setItem(key, String(Date.now()));
  window.location.reload();
};
window.addEventListener('error', (ev) => chunkReload(ev?.message || ev?.error?.message));
window.addEventListener('unhandledrejection', (ev) => chunkReload(ev?.reason?.message || ev?.reason));


// iter 205 — Global error tracking (frontend → backend)
installErrorTracker(axios);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

registerServiceWorker();
